export var PasswordRights;
(function (PasswordRights) {
    PasswordRights["READ_ONLY"] = "readOnly";
    PasswordRights["CAN_MODIFY"] = "canModify";
})(PasswordRights || (PasswordRights = {}));
